import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CheckPlatformService } from '@services/helper/check-platform.service';

/**
 * MFA must only be used on the signed-in user’s own profile (`/my-preferences/mfa`).
 * Visiting `/users/:id/mfa` or `/users-dev/:id/mfa` redirects to that user’s personal details.
 */
export const ownProfileMfaGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const checkPlatform = inject(CheckPlatformService);
  if (!checkPlatform.isBrowser()) {
    return true;
  }

  const path = state.url.split('?')[0];
  if (path.startsWith('/my-preferences')) {
    return true;
  }

  const match = path.match(/^\/(users-dev|users)\/([^/]+)(?:\/|$)/);
  if (match) {
    const [, prefix, id] = match;
    return router.createUrlTree(['/', prefix, id, 'personal-details']);
  }

  return router.createUrlTree(['/my-preferences', 'personal-details']);
};
